import {Api} from "@configs/api/api"
import apiConfig from "@configs/api/api.config"
import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
const API_POPUP = "/api/cms/v1/api/popups";
const API_POPUP_TYPES = "/api/cms/v1/api/popup-types";
const API_ACTIVE_POPUP ="/api/cms/v1/api/popups/unactive";
const API_PUBLISH_POPUP="/api/cms/v1/api/popups/id";
const API_CREATE_NEW_POPUP="/api/cms/v1/api/popups";
const INCLUDE_UNPUBLISHED_QUERY = "includeUnpublished=true";
class BaseApi extends Api {
    public constructor(config: AxiosRequestConfig){
        super(config);
        this.fetchPopupList =  this.fetchPopupList.bind(this);
        this.fetchActivePopup = this.fetchActivePopup.bind(this);
        this.fetchPublishPopup = this.fetchPublishPopup.bind(this);
        this.fetchCreateNewPopup = this.fetchCreateNewPopup.bind(this);
        this.fetchPopupId = this.fetchPopupId.bind(this);
        this.fetchPopupTypes = this.fetchPopupTypes.bind(this);
        this.createPopupType = this.createPopupType.bind(this);
        this.deletePopupType = this.deletePopupType.bind(this);
    }
    public fetchPopupTypes (): Promise<any>{
        const header = {"Authorization": localStorage.getItem("sid"), "x-role-context": "admin"}
        return this.get<any>(`${API_POPUP_TYPES}`,
        {
            headers: header
        })
        .then((res: AxiosResponse<any>)=>{
            const {data} = res;
            return data
        })
        .catch((err: AxiosError)=>{
            throw err;
        })
    }
    public createPopupType (body: any): Promise<any>{
        const header = {"Authorization": localStorage.getItem("sid"), "x-role-context": "admin", "Content-Type": "application/json"}
        return this.post<any>(`${API_POPUP_TYPES}`, JSON.stringify(body),
        {
            headers: header
        })
        .then((res: AxiosResponse<any>)=>{
            const {data} = res;
            return data
        })
        .catch((err: AxiosError)=>{
            throw err;
        })
    }
    public deletePopupType (id: any): Promise<any>{
        const header = {"Authorization": localStorage.getItem("sid"), "x-role-context": "admin"}
        return this.delete<any>(`${API_POPUP_TYPES}/${encodeURIComponent(id)}`,
        {
            headers: header
        })
        .then((res: AxiosResponse<any>)=>{
            const {data} = res;
            return data
        })
        .catch((err: AxiosError)=>{
            throw err;
        })
    }
    public fetchPopupId (params: any): Promise<any>{
        const header = {"Authorization": localStorage.getItem("sid"), "x-role-context": "admin"}
        return this.get<any>(`${API_POPUP}?${INCLUDE_UNPUBLISHED_QUERY}&id=${encodeURIComponent(params.id)}`,
        {
            headers: header
        })
        .then((res: AxiosResponse<any>)=>{
            const {data} = res;
            return data
        })
        .catch((err: AxiosError)=>{
            throw err;
        })
    }
    public fetchCreateNewPopup (body: any): Promise<any>{
        const bodyForm = body.bodyForm
        const header = {"Authorization": localStorage.getItem("sid"), "x-role-context": "admin"}
        const idQuery = body.id ? `?id=${encodeURIComponent(body.id)}` : ''
        return this.post<any>(`${API_CREATE_NEW_POPUP}${idQuery}`, JSON.stringify({bodyForm}),
            {
                headers: header
            }
        )
        .then((res: AxiosResponse<any>)=>{
            const {data} = res;
            return data
        })
        .catch((err: AxiosError)=>{
            throw err;
        })
    }
    public fetchPopupList (params: any): Promise<any>{
        const header = {"Authorization": localStorage.getItem("sid"), "x-role-context": "admin"}
        return this.get<any>(`${API_POPUP}?${INCLUDE_UNPUBLISHED_QUERY}&page=${params.page || 1}&limit=10`
        + (params.startDate ? `&startDate=${params.startDate}` : '')
        + (params.endDate ? `&endDate=${params.endDate}` : '')
        + (params.popupPosition ? `&popupPosition=${params.popupPosition}`:'')
        + (params.title ? `&title=${params.title}` : '')
        + (params.country ? `&country=${encodeURIComponent(params.country)}` : '')
        + (params.id? `&id=${params.id}`:''), 
        {
            headers: header
        }
        )
        .then((res: AxiosResponse<any>)=>{
            const {data} = res;
            return data
        })
        .catch((err: AxiosError)=>{
            throw err;
        })
    }
 
    public fetchActivePopup (id: any): Promise<any>{
        const ids = id.id
        const header ={"Authorization": localStorage.getItem("sid"), "x-role-context": "admin"}
        return this.put<any>(`${API_ACTIVE_POPUP}`, JSON.stringify({id: ids})
        , {
            headers: header
        }
        )
        .then((res: AxiosResponse<any>)=>{
            const {data} = res;
            return data
        })
        .catch((err: AxiosError)=>{
            throw err;
        })
    }

    public fetchPublishPopup (params: any): Promise<any>{
        const header ={"Authorization": localStorage.getItem("sid"), "x-role-context": "admin"}
        const publish = params.publish === true || params.publish === 'true'
        return this.put<any>(`${API_PUBLISH_POPUP}/${params.id}?publish=${encodeURIComponent(String(publish))}`, JSON.stringify({ publish })
        , {
            headers: header
        }
        )
        .then((res: AxiosResponse<any>)=>{
            const {data} = res;
            return data
        })
        .catch((err: AxiosError)=>{
            throw err;
        })
    }
}
const baseApi = new BaseApi(apiConfig);
export default baseApi;
